import { useEffect, useState } from "react"
import { toast } from "sonner"
import { subscribeToPush } from "../lib/subscribe-push"
import { usePushSubscription } from "./use-push-subscription"

type Trigger = "login" | "attend"

const canOffer = (trigger: Trigger, subscription: PushSubscription | null | undefined) =>
  typeof window !== "undefined" &&
  typeof Notification !== "undefined" &&
  subscription === null &&
  Notification.permission === "default" &&
  localStorage.getItem(`pushPromptShown.${trigger}`) !== "true"

const markShown = (trigger: Trigger) => {
  localStorage.setItem(`pushPromptShown.${trigger}`, "true")
}

export const usePushPromptDrawer = () => {
  const { subscription } = usePushSubscription()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (subscription === undefined) return
    if (!canOffer("login", subscription)) return
    markShown("login")
    setOpen(true)
  }, [subscription])

  return { open, onClose: () => setOpen(false) }
}

export const usePushPromptToast = () => {
  const { subscription } = usePushSubscription()
  return {
    offer: () => {
      if (!canOffer("attend", subscription)) return
      markShown("attend")
      toast("Присылать напоминание о событии?", {
        action: {
          label: "Включить",
          onClick: () => {
            subscribeToPush().catch(() => toast.error("Не удалось включить уведомления"))
          },
        },
      })
    },
  }
}
